export const YOUR_FIREBASE_CONFIG = {
  apiKey: "AIzaSyBGJ-aWC_mwFLK5Ct8BF3X1IC--3G41MiI",
  authDomain: "shep-s-sniff-spot.firebaseapp.com",
  projectId: "shep-s-sniff-spot",
  storageBucket: "shep-s-sniff-spot.firebasestorage.app",
  messagingSenderId: "608730451506",
  appId: "1:608730451506:web:fd79f89276989d18bff62b",
};

export const ADMIN_WHATSAPP_WEBHOOK_URL_1 ="https://api.callmebot.com/whatsapp.php?phone=+27678096947&apikey=1824276"; 
export const ADMIN_WHATSAPP_WEBHOOK_URL_2 ="https://api.callmebot.com/whatsapp.php?phone=+27723843366&apikey=4655741";        
export const SNIFFSPOT_LOGO_URL = "https://firebasestorage.googleapis.com/v0/b/shep-s-sniff-spot.firebasestorage.app/o/artifacts%2Fshep-s-sniff-spot%2FLogo%2FHappy%20Hounds%20Logo.jpg?alt=media&token=58898090-c172-4c96-90da-85a73d6a00cd";
export const LOGIN_BACKGROUND_URL = "https://firebasestorage.googleapis.com/v0/b/shep-s-sniff-spot.firebasestorage.app/o/artifacts%2Fshep-s-sniff-spot%2FLogo%2FHappy%20Hounds%20Logo%20Backround%201280X868.jpg?alt=media&token=7aa08593-1cf6-4a6e-b986-8234ec2ff690";
export const NOT_AVAILABLE_URL = "https://firebasestorage.googleapis.com/v0/b/shep-s-sniff-spot.firebasestorage.app/o/artifacts%2Fshep-s-sniff-spot%2FLogo%2FNot%20available%20Logo.jpg?alt=media&token=e2e81f4b-d359-436a-a598-5267453d5315";

export const BANKING_DETAILS = {
    bank: "FNB (First National Bank)",
    accountName: "Shep's Sniff Spot",
    accountNumber: "63124028473",
    branchCode: "250655",
    qrCodeUrl: "https://firebasestorage.googleapis.com/v0/b/shep-s-sniff-spot.firebasestorage.app/o/artifacts%2Fshep-s-sniff-spot%2FLogo%2FBanking%20QR%20Code.png?alt=media&token=39b335ba-28e2-4991-9493-f494400a3c7c",
};

export const petData = {
  Dog: [
    "Africanis", "Australian Shepherd", "Beagle", "Bernese Mountain Dog", "Boerboel", "Border Collie", 
    "Boston Terrier", "Boxer", "Bull Terrier", "Bulldog", "Cavalier King Charles Spaniel", "Chihuahua", 
    "Cocker Spaniel", "Dachshund", "Doberman Pinscher", "French Bulldog", "German Shepherd", 
    "German Shorthaired Pointer", "Golden Retriever", "Great Dane", "Jack Russell Terrier", 
    "Labrador Retriever", "Maltese", "Miniature Schnauzer", "Pembroke Welsh Corgi", "Pomeranian", 
    "Poodle", "Pug", "Rhodesian Ridgeback", "Rottweiler", "Shetland Sheepdog", "Shih Tzu", 
    "Siberian Husky", "Staffordshire Bull Terrier", "Yorkshire Terrier", "Other"
  ],
  Cat: [
    "Abyssinian", "Bengal", "Birman", "British Shorthair", "Maine Coon", "Persian", "Ragdoll", 
    "Scottish Fold", "Siamese", "Sphynx", "Other"
  ],
  Bird: ["Canary", "Cockatiel", "Finch", "Parakeet", "Parrot", "Other"],
  Other: ["Other"]
};
